module.exports = __webpack_public_path__ + "img/signs (2).f7cfa161.svg";